import { SlAlert } from "@shoelace-style/shoelace";
import '@shoelace-style/shoelace/dist/components/icon/icon.js';

// Always escape HTML for text arguments!
function escapeHtml(html: string) {
  const div = document.createElement('div');
  div.textContent = html;
  return div.innerHTML;
}

export interface NotificationParams {
  variant: string,
  closable: boolean,
  icon: string,
  duration: number | undefined,
}

export const InfoNotificationParams: NotificationParams = {
  closable: true,
  duration: 3000,
  icon: 'info-circle',
  variant: 'primary'
}

export const SuccessNotificationParams: NotificationParams = {
  closable: true,
  duration: 3000,
  icon: 'check2-circle',
  variant: 'success'
}

export const NeutralNotificationParams: NotificationParams = {
  closable: true,
  duration: 3000,
  icon: 'gear',
  variant: 'neutral'
}

export const WarningNotificationParams: NotificationParams = {
  closable: true,
  duration: 5000,
  icon: 'exclamation-triangle',
  variant: 'warning'
}

export const ErrorNotificationParams: NotificationParams = {
  closable: true,
  icon: 'exclamation-octagon',
  duration: 5000,
  variant: 'danger'
}


// Custom function to emit toast notifications
export function notify(message: string, params: NotificationParams) {
  // append the alert to the document
  // @see: https://shoelace.style/components/alert#creating-toasts-imperatively
  const alert: SlAlert = document.createElement('sl-alert');
  document.body.append(alert);
  Object.assign(
    alert,
    {
      variant: params.variant,
      closable: !!params.closable,
      duration: params.duration
    },
    {
      innerHTML: `
        <sl-icon name="${params.icon}" slot="icon"></sl-icon>
        ${escapeHtml(message)}
      `
    });

  return alert.toast();
}